<template>
  <div v-if="!isResinous()">
    <div class="row">
      <div class="col-lg-12 mb-2">
        <h4
          class="font-weight-bold primary-heading text-lowercase patcraft-text-underline"
          :data-text="coordinatingTitle ? coordinatingTitle.slice(0, 3) : ''"
        >
          {{ coordinatingTitle }}
        </h4>
      </div>
      <div class="col-lg-12">
        <div class="row">
          <div
            class="product-display-control-coordinating-products col-md-2 mt-3 mt-xl-0 px-3"
          >
            <button
              v-show="selectedCordinatingProducts && selectedCordinatingProducts.flag"
              class="btn dropdown-toggle px-1"
              type="button"
              id="dropdownPriceLabel"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              :class="priceTag ? 'disabled' : ''"
              :disabled="priceTag"
            >
              <p class="pl-2 m-0 mr-auto text-truncate">
                {{ $resourceString["product.Details.Price.Label"] }}
              </p>
              <span class="png-icon png-icon-icons-glyph--g-chevron-down"></span>
            </button>
            <div
              class="dropdown-menu"
              aria-labelledby="dropdownPriceLabel"
              v-if="coordinatingProductsFilters && coordinatingProductsFilters.Prices"
            >
              <div
                class="custom-control custom-checkbox"
                v-for="price in coordinatingProductsFilters.Prices"
                :key="price"
              >
                <div
                  class="dropdown-item dropdown-item-collection pt-0 text-truncate custom-control custom-checkbox"
                >
                  <input
                    :id="price"
                    :value="price"
                    type="checkbox"
                    class="custom-control-input"
                    :checked="
                      coordinatingProductsFiltersSelected &&
                      coordinatingProductsFiltersSelected.price &&
                      coordinatingProductsFiltersSelected.price.some(
                        i => i === price
                      )
                    "
                    @click="
                      clickCoordinatingFilter({
                        type: '',
                        category: price,
                        inputFilter: 'price'
                      })
                    "
                  />
                  <label class="custom-control-label pt-2" :for="price">
                    {{ price }}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <!-- Similar checks for productType dropdown -->
          <div
            class="product-display-control-coordinating-products col-md-3 mt-3 mt-xl-0"
          >
            <button
              v-show="selectedCordinatingProducts.flag"
              class="btn dropdown-toggle px-1"
              type="button"
              id="dropdownProductType"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              :class="productType ? 'disabled' : ''"
              :disabled="productType"
            >
              <p class="pl-2 m-0 mr-auto text-truncate">
                {{ $resourceString["benjaminMoore.Preview.ProductType"] }}
              </p>
              <span
                class="png-icon png-icon-icons-glyph--g-chevron-down"
              ></span>
            </button>
            <div class="dropdown-menu dropdown-menu-product-type" aria-labelledby="dropdownProductType">
              <div
                class="custom-control custom-checkbox"
                v-for="(productType, index) in coordinatingProductsFilters.ProductTypes"
                :key="productType.Name"
              >
                <p class="coordinating-products-filter-heading text-uppercase">
                  {{ productType.Name }}
                </p>
                <div
                  class="dropdown-item dropdown-item-collection pt-0 text-truncate custom-control custom-checkbox"
                  v-for="category in productType.SubTypes"
                  :key="productType.Name + category"
                >
                  <input
                    :id="productType.Name + '-' + category"
                    :key="productType.Name + '-' + category"
                    type="checkbox"
                    class="custom-control-input"
                    :value="category"
                    :checked="
                      coordinatingProductsFiltersSelected.productType[
                        productType.Name
                      ] &&
                        coordinatingProductsFiltersSelected.productType[
                          productType.Name
                        ].some(i => i.toLowerCase() === category.toLowerCase())
                    "
                    @click="
                      clickCoordinatingFilter({
                        type: productType.Name,
                        category: category,
                        inputFilter: 'productType'
                      })
                    "
                  />
                  <label
                    class="custom-control-label pt-2"
                    :for="productType.Name + '-' + category"
                    >{{ category }}</label
                  >
                </div>
                <hr v-if="index < coordinatingProductsFilters.ProductTypes.length - 1"/>
              </div>
            </div>
          </div>
          <div class="col-md-7 d-flex mt-3 mt-xl-0">
            <div
              class="btn-group btn-group-toggle w-100 d-md-flex justify-content-end"
            >
              <p
                @click="setCoordinatingProductsTab('Color')"
                class="text-center coordinating-products-tab text-uppercase d-block d-md-inline-block coordinating-products-tab-color"
                :class="[
                  selectedCordinatingProducts.currentTab == 'Color'
                    ? 'selected-coordinating-products'
                    : ''
                ]"
              >
                {{ $resourceString["assetIndex.Filters.Color"] }}
              </p>
              <p
                @click="setCoordinatingProductsTab('Collection')"
                class="text-center coordinating-products-tab border-left-0 text-uppercase d-block d-md-inline-block coordinating-products-tab-collection"
                :class="[
                  selectedCordinatingProducts.currentTab == 'Collection'
                    ? 'selected-coordinating-products'
                    : ''
                ]"
              >
                {{ $resourceString["assetIndex.Filters.Collection"] }}
              </p>
            </div>
          </div> 
        </div>
      </div>
    </div>

    <div class="mt-4 d-flex flex-wrap">
      <div class="similar-products-initial-image d-none d-lg-block">
        <img
          class="img-fluid"
          :src="
            selectedProduct && selectedColor
              ? $helpers.getColorThumbnailImageUrl(
                  selectedProduct.sellingStyleNumber,
                  selectedColor.colorNumber
                )
              : defaultImage
          "
          alt="img"
          @error="handleImageError"
        />
        <div class="mt-3 description text-uppercase">
          <strong>
            {{ $resourceString["product.Details.ThisStyle.Label"] }}: <br />
            {{ selectedColor && selectedColor.colorName }}
            {{ selectedColor && selectedColor.colorNumber }}
            <br />
            {{ productData && productData.sellingStyleName }}
            {{ selectedProduct && selectedProduct.sellingStyleNumber }}
          </strong>
        </div>
      </div>
      <div class="similar-products-carsole">
        <div
          v-if="
            !coordinatingProducts ||
            coordinatingProducts.length === 0 ||
            fetchingCoordinatingProducts
          "
          class="text-center"
        >
          <p
            class="mt-5"
            v-if="
              coordinatingProducts &&
              coordinatingProducts.length === 0 &&
              !fetchingCoordinatingProducts
            "
          >
            {{ $resourceString["producT.CoordinatingProductsMessage"] }}
          </p>
          <p class="mt-5" v-else>
            <pc-load-more
              v-if="fetchingCoordinatingProducts"
              :load-more="onLoadMore"
            />
          </p>
        </div>
        <div v-else class="pc-product-coordinating-carousel">
          <VueSlickCarousel
            v-bind="settings"
            v-if="coordinatingProducts && coordinatingProducts.length > 0"
          >
            <template #nextArrow>
              <button type="button" class="custom-arrow-next">
                <span
                  class="png-icon png-icon-icons-glyph--k-chevron-right"
                ></span>
              </button>
            </template>
            <template #prevArrow>
              <button type="button" class="custom-arrow-prev">
                <span
                  class="png-icon png-icon-icons-glyph--k-chevron-left"
                ></span>
              </button>
            </template>
            <div
              class="carsole-img-cpd"
              v-for="listProducts in coordinatingProducts"
              :key="listProducts.ColorNumber"
            >
              <a
                class="cart-item-model-no"
                :href="
                  $helpers.getProductDetailUrl(
                    listProducts.StyleNameURL,
                    listProducts.SellingStyleNumber,
                    listProducts.ColorNumber
                  )
                "
              >
                <img
                  class="img-fluid"
                  :src="listProducts.ImagePath || defaultImage"
                  alt="img"
                  @error="handleImageError"
                />
              </a>
              <div class="mt-3 description text-uppercase">
                <strong>
                  <u>
                    {{ listProducts.ColorName || 'N/A' }}
                    {{ listProducts.ColorNumber || 'N/A' }}
                  </u>
                </strong>
                <div>{{ listProducts.Collection || 'N/A' }}</div>
                <a
                  href="javascript:void(0)"
                  id="add-to-cart"
                  :class="OrderSampleEnabled ? 'text-muted pointer-none' : ''"
                  @click.prevent="OrderSampleEnabled ? '' : addItemToCart(listProducts)"
                >
                  {{ $resourceString["product.Details.AddToBasket.Label"] }}
                </a>
              </div>
            </div>
          </VueSlickCarousel>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters, mapActions } from "vuex";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import PcLoadMore from "../common/pc-loading-more.vue";
import { globalIcons } from "../../../constants/global";
export default {
  data() {
    return {
      settings: {
        centerMode: false,
        centerPadding: "15px",
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true
      },
      coordinatingTitle: this.$resourceString["producT.CoordinatingProducts"],
      defaultImage: globalIcons.defaultImage
    };
  },

  components: { VueSlickCarousel, PcLoadMore },
  computed: {
    ...mapGetters({
      selectedProduct: "productDetail/selectedProduct",
      selectedColor: "productDetail/color",
      fetchingCoordinatingProducts:
        "productDetail/fetchingCoordinatingProducts",
      coordinatingProducts: "productDetail/coordinatingProducts",
      productData: "productDetail/productData",
      coordinatingProductsFilters: "productDetail/coordinatingProductsFilters",
      selectedCordinatingProducts:
        "productDetail/selectedCoordinatingProductsTab",
      coordinatingProductsFiltersSelected:
        "productDetail/coordinatingProductsFiltersSelected",
      OrderSampleEnabled: "productDetail/getisOrderSampleEnabled"
    }),

    priceTag() {
      if (Array.isArray(this.coordinatingProductsFilters)) {
        return true;
      }
      return this.coordinatingProductsFilters?.Prices?.length === 0;
    },
    productType() {
      if (Array.isArray(this.coordinatingProductsFilters)) {
        return true;
      }
      return this.coordinatingProductsFilters?.ProductTypes?.length === 0;
    }
  },
  methods: {
    ...mapActions({
      addToCart: "newBasketPage/addToCart",
      setCoordinatingProductsTab: "productDetail/setCoordinatingProductsTab",
      clickCoordinatingFilter: "productDetail/clickCoordinatingFilter",
      isOrderSampleEnabled: "productDetail/isOrderSampleEnabled"
    }),

    handleImageError(event) {
      event.target.src = this.defaultImage;
    },
    isResinous() {
      return (
        this.productData &&
        this.productData.inventoryType === this.$resourceString["resinous.InventoryType"]
      );
    },
    onLoadMore() {
      return;
    },
    addItemToCart(currentProduct) {
      let data = {
        sellingStyleNumber: currentProduct.SellingStyleNumber,
        colorNumber: currentProduct.ColorNumber
      };
      this.addToCart(data);
    }
  }
};
</script>
